import React, { Fragment, useEffect, useState } from 'react';

const Loader = (props) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
     
    const timeout = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => {
       
      clearTimeout(timeout);
    };
  }, [show]);
  return (
    <Fragment>
      <div className={`loader-wrapper ${show ? '' : 'loaderhide'}`}>
        <img
          src={`${process.env.PUBLIC_URL}/favicon-icon-modified.png`}
          alt="Logo"
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />

        {/* <div className="loader">
          <div className="loader-bar"></div>
          <div className="loader-bar"></div>
          <div className="loader-bar"></div>
          <div className="loader-bar"></div>
          <div className="loader-bar"></div>
          <div className="loader-ball"></div>
        </div> */}
      </div>
    </Fragment>
  );
};
export default Loader;